module.exports = __webpack_public_path__ + "static/media/computer.f4ccc591.png";